module.exports = __webpack_public_path__ + "img/symbol_12_free.71703d20.png";